/*
 * @Author: huangshimin@klcxkj.com
 * @Date: 2022-03-28 16:41:39
 * @LastEditors: huangshimin@klcxkj.com
 * @LastEditTime: 2022-04-19 21:05:40
 * @FilePath: \client-h5\src\pages\orderDetail\services.js
 */
import http from '../../utils/http';

//订单明细
export function getOrderDetail(params) {
  return http("get", '/order/getdetail',params);
}


